import { type OfferV11 } from '@redteclab/api/clients/bully'

export const offerAccessorOtherOffersHaveVolumePricing = (
  offers: OfferV11[] | undefined,
  currentOffer: OfferV11 | undefined,
): boolean => {
  if (offers && currentOffer) {
    const currentOfferId = currentOffer.offerId

    return offers.some(
      ({ offerId, volumeBasedPrices }) =>
        offerId !== currentOfferId &&
        volumeBasedPrices &&
        volumeBasedPrices.length > 1,
    )
  }

  return false
}
